export const DEFAULT_FOLDER_NAMES = {
  'uploaded-video': 'HTML5'
} as const;
